<template>
  <div class="modal_wrap" :class="{ on: isOpen }">
    <!--'on 추가'-->
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_head">
          <h1 class="h1">개통 유형 선택</h1>
        </div>
        <div class="modal_con">
          <div class="form_wrap">
            <div class="check_table" data-columns="">
              <!--'2열: data-columns="2"', '3열: data-columns="3"'-->
              <label v-for="(item, index) in deviceColor" :key="index"
                ><input
                  type="radio"
                  name="booking_color"
                  v-model="color"
                  :value="item"
                /><span>{{ item }}</span></label
              >
            </div>
          </div>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap">
            <button class="btn bo grey" v-on:click="$emit('close')">
              닫기
            </button>
            <button class="btn" v-on:click="$emit('select', color)">
              확인
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ColorModal',
  props: {
    deviceColor: Array,
  },
  created() {
    //alert(this.fColor);
  },
  data() {
    return {
      // deviceColor: ['빨강', '주황', '노랑'],
      color: '',
      isOpen: false,
    };
  },
};
</script>
